module.exports = __webpack_public_path__ + "img/asset6.ce5362f4.svg";